import { render } from "./CoursesDetailView.vue?vue&type=template&id=4dff5fca&scoped=true"
import script from "./CoursesDetailView.vue?vue&type=script&lang=js"
export * from "./CoursesDetailView.vue?vue&type=script&lang=js"

import "./CoursesDetailView.vue?vue&type=style&index=0&id=4dff5fca&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dff5fca"]])

export default __exports__